import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://linuxsecops.org";
const DEFAULT_IMAGE = `${SITE_URL}/LSOpub.png`;

function toAbsoluteUrl(path) {
  const normalizedPath = path && path.startsWith("/") ? path : `/${path || ""}`;
  return `${SITE_URL}${normalizedPath}`;
}

export default function Seo({
  title,
  description,
  path = "/",
  type = "website",
  image = DEFAULT_IMAGE,
  jsonLd,
}) {
  const canonicalUrl = toAbsoluteUrl(path);
  const schemaItems = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {schemaItems.map((schemaItem, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schemaItem)}
        </script>
      ))}
    </Helmet>
  );
}
